module.exports = __webpack_public_path__ + "static/media/icon-orgaos.d856853b.svg";